/**
 * Vite build modes — kept in a standalone file (no `import.meta.env`) so
 * they can be referenced from both runtime code and `vite.config.ts`.
 */
export const MODE = {
  DEVELOPMENT: "development",
  TEST: "test",
  STAGING: "staging",
  PRODUCTION: "production",
} as const;

export type Mode = (typeof MODE)[keyof typeof MODE];
